import { render } from "./PromptSuggestionComponent.vue?vue&type=template&id=533f3160&scoped=true"
import script from "./PromptSuggestionComponent.vue?vue&type=script&lang=js"
export * from "./PromptSuggestionComponent.vue?vue&type=script&lang=js"

import "./PromptSuggestionComponent.vue?vue&type=style&index=0&id=533f3160&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-533f3160"]])

export default __exports__